import React, { useEffect, useRef } from 'react';

export default function EduLearningGraph() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;
    const ctx = canvas.getContext('2d');

    let width = 0;
    let height = 0;
    let nodes = [];
    let edges = [];
    let animationFrameId = null;

    const resizeCanvas = () => {
      const rect = canvas.parentElement.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;
      width = rect.width;
      height = rect.height;
      canvas.width = width * dpr;
      canvas.height = height * dpr;
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };

    const initGraph = () => {
      const count = 24;
      nodes = Array.from({ length: count }, () => ({
        x: Math.random() * width,
        y: Math.random() * height,
        vx: (Math.random() - 0.5) * 0.1,
        vy: (Math.random() - 0.5) * 0.1,
        r: 1.8 + Math.random() * 1.8,
      }));
      edges = [];
      for (let i = 0; i < nodes.length; i++) {
        const linkCount = 1 + Math.floor(Math.random() * 2);
        for (let j = 0; j < linkCount; j++) {
          const target = Math.floor(Math.random() * nodes.length);
          if (target !== i) edges.push([i, target]);
        }
      }
    };

    const drawGraph = () => {
      ctx.clearRect(0, 0, width, height);

      nodes.forEach((n) => {
        n.x += n.vx;
        n.y += n.vy;
        if (n.x < 0 || n.x > width) n.vx *= -1;
        if (n.y < 0 || n.y > height) n.vy *= -1;
      });

      edges.forEach(([a, b]) => {
        const n1 = nodes[a];
        const n2 = nodes[b];
        const dist = Math.hypot(n1.x - n2.x, n1.y - n2.y);
        const maxDist = Math.max(width, height) * 0.6;
        const alpha = Math.max(0, 1 - dist / maxDist) * 0.3;
        if (alpha <= 0) return;
        ctx.strokeStyle = `rgba(74,64,32,${alpha})`;
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(n1.x, n1.y);
        ctx.lineTo(n2.x, n2.y);
        ctx.stroke();
      });

      nodes.forEach((n) => {
        ctx.fillStyle = 'rgba(74,64,32,0.75)';
        ctx.beginPath();
        ctx.arc(n.x, n.y, n.r, 0, Math.PI * 2);
        ctx.fill();
      });

      animationFrameId = requestAnimationFrame(drawGraph);
    };

    const setupGraph = () => {
      resizeCanvas();
      initGraph();
    };

    setupGraph();
    window.addEventListener('resize', setupGraph);
    animationFrameId = requestAnimationFrame(drawGraph);

    return () => {
      window.removeEventListener('resize', setupGraph);
      if (animationFrameId !== null) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, []);

  return (
    <div className="edu-landing-graph-canvas-wrap">
      <canvas ref={canvasRef} />
    </div>
  );
}
